/**
 * 解約機能の型定義
 */

// 解約理由の定数定義
export const CANCELLATION_REASONS = {
  PRICE_TOO_HIGH: 'price_too_high',
  NOT_USING: 'not_using',
  SWITCHING_COMPETITOR: 'switching_competitor',
  FEATURES_INSUFFICIENT: 'features_insufficient',
  DIFFICULT_TO_USE: 'difficult_to_use',
  BUSINESS_CLOSED: 'business_closed',
  TEMPORARY_PAUSE: 'temporary_pause',
  OTHER: 'other',
} as const;

// 解約理由の型
export type CancellationReason = typeof CANCELLATION_REASONS[keyof typeof CANCELLATION_REASONS];

// 解約理由のラベル
export const CANCELLATION_REASON_LABELS: Record<CancellationReason, string> = {
  [CANCELLATION_REASONS.PRICE_TOO_HIGH]: '料金が高い',
  [CANCELLATION_REASONS.NOT_USING]: '使っていない',
  [CANCELLATION_REASONS.SWITCHING_COMPETITOR]: '他のサービスに移行する',
  [CANCELLATION_REASONS.FEATURES_INSUFFICIENT]: '必要な機能がない',
  [CANCELLATION_REASONS.DIFFICULT_TO_USE]: '使いづらい',
  [CANCELLATION_REASONS.BUSINESS_CLOSED]: '事業を終了する',
  [CANCELLATION_REASONS.TEMPORARY_PAUSE]: '一時的に利用を休止する',
  [CANCELLATION_REASONS.OTHER]: 'その他',
};

// 解約申請ステータスの定数定義
export const CANCELLATION_REQUEST_STATUS = {
  PENDING: 'pending',
  EFFECTIVE: 'effective',
  UNDONE: 'undone',
} as const;

// 解約申請ステータスの型
export type CancellationRequestStatus = typeof CANCELLATION_REQUEST_STATUS[keyof typeof CANCELLATION_REQUEST_STATUS];

// 解約申請ステータスのラベル
export const CANCELLATION_REQUEST_STATUS_LABELS: Record<CancellationRequestStatus, string> = {
  [CANCELLATION_REQUEST_STATUS.PENDING]: '申請中',
  [CANCELLATION_REQUEST_STATUS.EFFECTIVE]: '有効',
  [CANCELLATION_REQUEST_STATUS.UNDONE]: '取り消し',
};
